//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {Toast} from "vant";
import vueQr from 'vue-qr';
import global from '../../../static/js/global.js'
//import QRCode from 'qrcodejs2'
export default {
  components: {
    [vueQr.name]: vueQr,
    [Toast.name]: Toast
  },
  data() {
    return {
      num: "",
      imgUrl: "../../../static/image/house_icon.png",
      codeText: "",
      dateTime: ""
    };
  },
  mounted() {
    this.initPage();
  },
  methods: {
      creatQrCode() {
        this.$http.get(global.host + 'guardCard/visitorQrcode?authCode='+this.num).then(function(res){
            console.log("res   ===   "+JSON.stringify(res));
            if(res.body.code == "200"){
                if(res.body.data){
                    $("#tel4").blur();
                    this.codeText = res.body.data;
                    this.dateTime = "失效时间："+res.body.message;
                    // var qrcode = new QRCode(this.$refs.qrCodeUrl, {
                    //     text: this.codeText, // 需要转换为二维码的内容
                    //     width: 100,
                    //     height: 100,
                    //     colorDark: '#000000',
                    //     colorLight: '#ffffff',
                    //     correctLevel: QRCode.CorrectLevel.H
                    // });
                }
            } else {
                $("#tel1").focus();
                Toast.fail({
                  message: res.body.message,
                  duration: 3000
                });
            }
        },function(err){
            $("#tel1").focus();
            Toast.fail({
              message: '服务异常，请稍后重试',
              duration: 3000
            });
        })
    },
    initPage() {
      $("#tel1").focus(function () {
        //第一个input框获得焦点时触发的事件
        var txts = $(".num input");
        for (var i = 0; i < txts.length; i++) {
          var t = txts[i];
          t.index = i;
          t.setAttribute("readonly", true);
          t.onkeyup = function() {
            this.value = this.value.replace(/^(.).*$/, "$1");
            var next = this.index + 1;
            if (next > txts.length - 1) return;
            txts[next].removeAttribute("readonly");
            if (this.value) {
              txts[next].focus();
            }
          };
        }
        txts[0].removeAttribute("readonly");
      });

      var that = this;
      $("#tel4").keyup(function() {
        var oLi = document.querySelectorAll("input");
        for (var i = 0; i < oLi.length; i++) {
          that.num += oLi[i].value;
        }
        console.log(that.num);
        that.creatQrCode();
      });

      $("#tel1").keydown(function() {
        that.num = "";
        var oLi = document.querySelectorAll("input");
        for (var i = 0; i < oLi.length; i++) {
          if(oLi[i].value){
            oLi[i].value = "";
          }
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/accessControl/visitorAccessQrcode.vue